<template>
  <div class="fascia-welfare">
      <b-row>
          <b-col sm="12" md="6">
              <div class="text clearfix">
                  <h4 class="black">Viaggia col welfare aziendale!</h4>
                  <br>
                  <p>
                    {{ site.brand }} è in tutti i principali portali di welfare aziendale. 
                    Per prenotare un viaggio con il tuo credito welfare devi accedere a {{ site.brand }} partendo dal link che trovi dentro il tuo portale di welfare aziendale.
                  </p>
                  <router-link class="float-right" :to="{name: 'about', hash:'#prenota-un-viaggio'}"><u>Scopri di più...</u></router-link>
              </div>
          </b-col>
          <b-col class="image" sm="12" md="6" style="background-image:url(/assets/images/liveeps/statics/fascia-welfare.jpg) "></b-col>
      </b-row>
  </div>
</template>

<script>

export default {
  name: 'fascia-welfare',
  props: {
  }, 
  components: {
  },
  data() {
      return {
        site: this.$config.site,
      }
  }
}
</script>

<style lang="scss">
  .fascia-welfare {
    margin: $grid-gutter-width/2;
    .row {
      background:$white;
      display:flex;
      align-items: center;
      overflow:hidden;
      border-radius: $border-radius-lg * 2;
    }
    .text {
      padding:$grid-gutter-width;
    }
    .image {
      min-height: 360px;
      background-position: 0 0;
      background-size: cover;
      background-repeat: no-repeat;

      @include media-breakpoint-down(lg) {
        background-position: -100px center;
      }

      @include media-breakpoint-down(md) {
        background-position: -180px center;
      }

      @include media-breakpoint-down(sm) {
        background-position: center center;
      }
    }
  }
</style>